import ButtonGsfurn from "components/General/ButtonGsfurn/ButtonGsfurn";
import { printHTML } from "hooks/utils/formatter";
import Image from "next/image";

const CallToActionBanner = ({ attrs }) => {
  const block_data = attrs?.data;
  const title = block_data?.banner_content_titel;
  const content = block_data?.banner_content_inhoud;
  const link_url = block_data?.banner_content_link?.url;
  const link_title = block_data?.banner_content_link?.title ?? "Configureren";

  return (
    <section className="px-4 mx-auto mb-16 md:mb-20 xl:px-0 max-w-app">
      <div className="relative w-full h-full overflow-hidden rounded-t-md md:rounded md:items-center md:flex">
        <div className="w-full h-full overflow-hidden">
          <div
            className="relative w-full h-60 md:h-[28.5rem]"
            data-scroll
            data-scroll-speed="-0.05"
            data-scroll-enable-touch-speed
          >
            <Image
              src={block_data?.afbeelding_banner?.url}
              alt={block_data?.afbeelding_banner?.alt}
              className="object-cover !-top-[20%] !h-[140%] md:!-top-[10%] md:!h-[120%]"
              fill
            />
          </div>
        </div>
        <div className="pl-6 pr-12 md:max-w-md py-7 md:pl-10 md:pr-9 md:py-10 md:absolute bg-dark-bg right-20 rounded-b-md md:rounded-10">
          {title && (
            <h2 className="leading-tight text-xl md:text-[1.375rem] mb-3 md:mb-5 text-white">
              {title}
            </h2>
          )}
          {content && (
            <div className="mb-6 text-[#A6B0B7]">
              {printHTML(block_data?.banner_content_inhoud)}
            </div>
          )}
          {link_url && (
            <a href={link_url} title={link_title}>
              <ButtonGsfurn color="primary_rounded" size="md" needsArrow>
                {link_title}
              </ButtonGsfurn>
            </a>
          )}
        </div>
      </div>
    </section>
  );
};

export default CallToActionBanner;
